namespace Portico.Models.Legacy {

	export enum AnswerType {
		// 1 Numeric
		// 2 Text
		// 3 Date
		// 4 Member Number
		// 5 Debit Card Account Number
		Numeric = 1,
		Text = 2,
		Date = 3,
		MemberNumber = 4,
		DebitCardAccountNumber = 5
	}
	export enum QuestionType {
		// 1	Member Number Collector
		// 2	Patient Object Collector
		// 3	Document ID
		// 4	Debit Card Number Collector
		// 5	Multiple Choice
		// 6	Multiple Choice Multi Answer
		// 7	Free Form
		// 8	Date
		// 9	Campaign Member ID Collector
		// 10	Campaign Stream ID Collector
		MemberNumberCollector = 1,
		PatientObjectCollector = 2,
		DocumentId = 3,
		DebitCardNumberCollector = 4,
		MultipleChoice = 5,
		MultipleChoiceMultipleAnswer = 6,
		FreeForm = 7,
		Date = 8,
		CampaignMemberIdCollector = 9,
		CampaignStreamIdCollector = 10
	}

	export enum CommunicationTypes {
		None = 0,
		Letter = 1,
		Email = 2,
		LetterEmail = 3,
		Sms = 4,
		LetterSms = 5,
		EmailSms = 6,
		LetterEmailSms = 7,
		NUMBER_8 = 8
	}

	export enum InsuranceType {
		Pharmacy = 1,
		Medical = 2,
		Both = 3
	}

	export enum NameMatchQueryTypeEnum {
		Exact = 0,
		StartsWith = 1,
		EndsWith = 2,
		Contains = 3
	}

	export enum EligibilityStatusCode {
		ValidButIneligible = 0,
		EligiblePendingSurvey = 1,
		PendingEnrollment = 2,
		InvalidMemberNumber = 3,
		ExpiredActivationPeriod = 4,
		ReadyToActivate = 5,
		TransferToTrialcard = 6
	}

	export enum CardAlternateIdTypeEnum {
		PreviousClientId = 1,
		MobileNumber = 2,
		ServiceRequestNumber = 3,
		ThirdPartyId = 4
	}

	export enum EligibilityStatusCodeEnum {
		NUMBER_0 = <any>0,
		NUMBER_1 = <any>1,
		NUMBER_2 = <any>2,
		NUMBER_3 = <any>3,
		NUMBER_4 = <any>4,
		NUMBER_5 = <any>5,
		NUMBER_6 = <any>6,
		NUMBER_MINUS_1 = <any>-1
	}
	export enum CommunicationTypesEnum {
		None = 0,
		Letter = 1,
		Email = 2,
		LetterEmail = 3,
		Sms = 4,
		LetterSms = 5,
		EmailSms = 6,
		LetterEmailSms = 7
	}
	export enum PrescriberCommunicationTypeEnum {
		None = 0,
		Letter = 1,
		Email = 2,
		LetterEmail = 3,
		Sms = 4,
		LetterSms = 5,
		EmailSms = 6,
		LetterEmailSms = 7,
		NUMBER_8 = <any>8
    }
    export enum PrescriberCommunicationOptionEnum {
        NUMBER_0 = <any>0,
        NUMBER_1 = <any>1,
        NUMBER_2 = <any>2,
    }
	export enum CommunicationTypeEnum {
		None = 0,
		Letter = 1,
		Email = 2,
		LetterEmail = 3,
		Sms = 4,
		LetterSms = 5,
		EmailSms = 6,
		LetterEmailSms = 7,
		NUMBER_8 = 8
    }
    export enum CommunicationOptionEnum {
        NUMBER_0 = <any>0,
        NUMBER_1 = <any>1,
        NUMBER_2 = <any>2,
    }
	export enum PaymentTypeEnum {
		NUMBER_0 = <any>0,
		NUMBER_1 = <any>1,
		NUMBER_2 = <any>2,
		NUMBER_3 = <any>3
	}
	export enum SiteTypeEnum {
		NUMBER_0 = <any>0,
		NUMBER_1 = <any>1,
		NUMBER_2 = <any>2
	}
    export enum SiteCommunicationTypesEnum {
		NUMBER_0 = <any>0,
		NUMBER_1 = <any>1,
		NUMBER_2 = <any>2,
		NUMBER_3 = <any>3,
		NUMBER_4 = <any>4,
		NUMBER_5 = <any>5,
		NUMBER_6 = <any>6,
		NUMBER_7 = <any>7,
		NUMBER_8 = <any>8
    }
    export enum SiteCommunicationOptionEnum {
        NUMBER_0 = <any>0,
        NUMBER_1 = <any>1,
        NUMBER_2 = <any>2,
    }
    export enum SourceIdEnum {
        NUMBER_0 = <any>0,
        NUMBER_5 = <any>6,
        NUMBER_6 = <any>5,
        NUMBER_7 = <any>7,
    }
	export enum RelationshipEnum {
        NUMBER_0 = <any> 0,
        NUMBER_1 = <any> 1,
        NUMBER_2 = <any> 2
	}
	export enum InsuranceTypeEnum {
        NUMBER_1 = <any> 1,
        NUMBER_2 = <any> 2,
        NUMBER_3 = <any> 3
	}
	export enum FirstNameQueryTypeEnum {
		Exact = <any>0,
		StartsWith = <any>1,
		EndsWith = <any>2,
		Contains = <any>3
	}
	export enum LastNameQueryTypeEnum {
		Exact = <any>0,
		StartsWith = <any>1,
		EndsWith = <any>2,
		Contains = <any>3
    }
    export enum PhoneTypeEnum {
        NUMBER_0 = <any>0,
        NUMBER_1 = <any>1,
        NUMBER_2 = <any>2,
        NUMBER_3 = <any>3
    }
}